module.exports = __webpack_public_path__ + "media/images/element/25-e1b93afd15d4224c01a22613880543bc.svg";